import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollManager: React.FC = () => {
  const { pathname } = useLocation();

  // Xử lý khi chuyển trang
  useEffect(() => {
    // Cuộn lên đầu khi chuyển trang
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Khôi phục vị trí scroll từ sessionStorage khi reload
    const handleLoad = () => {
      const savedScroll = sessionStorage.getItem(`scrollPos_${pathname}`);
      if (savedScroll) {
        window.scrollTo({ top: parseInt(savedScroll), behavior: 'auto' });
      }
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, [pathname]);

  // Lưu vị trí scroll khi cuộn
  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem(`scrollPos_${pathname}`, window.scrollY.toString());
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  return null;
};

export default ScrollManager;